var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgToiletter = function SvgToiletter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#113628",
    strokeMiterlimit: 10,
    strokeWidth: 0.942,
    d: "M1.5 10.744V6.562a2.204 2.204 0 1 1 4.408 0v4.182m2.344 0s.71-4.054 1.078-5.01c.311-.815 1.12-1.375 2.044-1.375s1.723.546 2.034 1.346c.386 1.008 1.093 4.93 1.093 4.93M2.86 9.61v5.65m1.69 0V9.61m7.916-2.076.927 4.473h-1.177v3.254m-1.935-7.727-.933 4.473h1.178v3.254M4.867 1.863a1.163 1.163 0 1 1-2.327 0 1.163 1.163 0 0 1 2.327 0Zm7.67 0a1.163 1.163 0 1 1-2.326 0 1.163 1.163 0 0 1 2.326 0Z"
  })));
};
export default SvgToiletter;